import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './AdminRooms.css'; // Custom CSS for admin page

const AdminRooms = () => {
  const [rooms, setRooms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedRoom, setSelectedRoom] = useState(null); // To track room to update

  useEffect(() => {
    // Fetch rooms data for admin view
    const fetchRooms = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/rooms`);
        setRooms(response.data);
        setLoading(false);
      } catch (err) {
        setError('Failed to load rooms. Please try again later.');
        setLoading(false);
      }
    };

    fetchRooms();
  }, []);

  const handleDeleteRoom = async (roomId) => {
    try {
      await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/rooms/${roomId}`);
      setRooms(rooms.filter((room) => room.id !== roomId)); // Remove room from the list
    } catch (err) {
      setError('Failed to delete the room. Please try again later.');
    }
  };

  const handleUpdateRoom = async () => {
    if (selectedRoom) {
      try {
        // Make API request to update room details
        const updatedRoom = await axios.put(`${process.env.REACT_APP_BACKEND_URL}/rooms/${selectedRoom.id}`, selectedRoom);
        setRooms(
          rooms.map((room) =>
            room.id === selectedRoom.id ? updatedRoom.data : room
          )
        );
        setSelectedRoom(null); // Reset selected room after update
      } catch (err) {
        setError('Failed to update the room. Please try again later.');
      }
    }
  };

  return (
    <div className="admin-rooms-container">
      <h1 className="admin-rooms-title">Admin Room Management</h1>

      {loading && <p>Loading rooms...</p>}
      {error && <p className="error-message">{error}</p>}

      <div className="rooms-grid">
        {rooms.length > 0 ? (
          rooms.map((room) => (
            <div key={room.id} className="room-card">
              <div className="room-image-container">
                {room.images && room.images.length > 0 ? (
                  <img
                    src={`${process.env.REACT_APP_BACKEND_URL}/${room.images[0]}`}
                    alt={room.room_type}
                    className="room-image"
                  />
                ) : (
                  <div className="no-image">No Image Available</div>
                )}
              </div>
              <div className="room-details">
                <h3>{room.room_type}</h3>
                <p>Price per Night: £{room.price_per_night}</p>
                <p>Max Persons: {room.max_persons}</p>
                <p>{room.description}</p>
                <button className="room-button" onClick={() => setSelectedRoom(room)}>
                  Update Room
                </button>
                <button className="delete-button" onClick={() => handleDeleteRoom(room.id)}>
                  Delete Room
                </button>
              </div>

              {/* Show Reservations for the Room */}
              <div className="reservations">
                <h4>Reservations:</h4>
                {room.reservations && room.reservations.length > 0 ? (
                  room.reservations.map((reservation) => (
                    <div key={reservation.id} className="reservation-item">
                      <p>{reservation.customer_name}</p>
                      <p>{reservation.check_in_date} to {reservation.check_out_date}</p>
                    </div>
                  ))
                ) : (
                  <p>No reservations for this room.</p>
                )}
              </div>
            </div>
          ))
        ) : (
          <p>No rooms available at the moment.</p>
        )}
      </div>

      {/* Update Room Modal */}
      {selectedRoom && (
        <div className="update-room-modal">
          <div className="modal-content">
            <h2>Update Room Details</h2>
            <form>
              <label>Room Type:</label>
              <select 
            className="form-select" 
            value={selectedRoom.room_type}
            onChange={(e) => setSelectedRoom({ ...selectedRoom, room_type: e.target.value })}
            required
          >
            <option value="">Select Room Type</option>
            <option value="family">Family Room</option>
            <option value="double">Double Room</option>
            <option value="twin">Twin Room</option>
          </select>

              <label>Price per Night:</label>
              <input
                type="number"
                value={selectedRoom.price_per_night}
                onChange={(e) => setSelectedRoom({ ...selectedRoom, price_per_night: e.target.value })}
              />

              <label>Max Persons:</label>
              <input
                type="number"
                value={selectedRoom.max_persons}
                onChange={(e) => setSelectedRoom({ ...selectedRoom, max_persons: e.target.value })}
              />

              <label>Description:</label>
              <textarea
                value={selectedRoom.description}
                onChange={(e) => setSelectedRoom({ ...selectedRoom, description: e.target.value })}
              />

              <button type="button" onClick={handleUpdateRoom} className="update-room-button">
                Update Room
              </button>
            </form>
            <button onClick={() => setSelectedRoom(null)} className="close-modal-button">
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminRooms;
